import $ from 'jquery';
import asimov from '@99designs/asimov-core';
import MediaQueryLabel from './lib/media-query-label';

var pluginName = 'mediaQueryLabel',
    defaults = {};

function build(options, elem) {
    var obj = new MediaQueryLabel().init(options, elem);

    // Public API

    return {
        is: function(breakpoint) {
            return obj.is(breakpoint);
        },
        get: function() {
            return obj.get();
        }
    };
}

// Plugin definition
//
$.fn[pluginName] = function(options) {
    return this.each(function() {
        if (!$.data(this, pluginName)) {
            var opts = asimov.mergeElementData(
                $(this),
                pluginName,
                $.extend(true, {}, defaults, options)
            );

            $.data(this, pluginName, build(opts, this));
        }
    });
};



// WEBPACK FOOTER //
// ./~/@99designs/asimov-media-query-label/index.js